import { CreateCouponForm } from '@/pages/admin/coupon-table'
import axios from '@/services/axios'

const fetchCoupons = async (
	data: FilterPayload,
): Promise<{ data: Coupon[]; pagination: Pagination }> => {
	const queryParams = new URLSearchParams()
	queryParams.append('page', data.pageNumber)
	queryParams.append('limit', data.pageSize)

	if (data.filterColumn && data.filterValue) {
		queryParams.append('filterColumn', data.filterColumn)
		queryParams.append('filterValue', data.filterValue)
	}

	const queryString = queryParams.toString()

	const response = await axios.get(`/couponRoute/coupons?${queryString}`)
	return response.data
}

const createCoupon = async (data: CreateCouponForm) => {
	const response = await axios.post('/couponRoute/create', {
		...data,
		redeem_count: 0,
		active: true,
	})
	return response.data
}

const deleteCoupon = async (id: Coupon['id']) => {
	const response = await axios.delete(`/couponRoute/${id}`)
	return response.data
}

const couponService = { fetchCoupons, createCoupon, deleteCoupon }

export default couponService
